import {createAsyncThunk} from '@reduxjs/toolkit';
import {COOKIE_EXPIRY_1_HOUR, setCookie} from '@Utils/cookie.util';
import type {AppliedPromoCode} from '@Panels/premium-pricing-panel/premium-pricing-panel.types';
import {SUBSCRIPTION_PROMOTION_CODE_COOKIE} from '@Panels/premium-pricing-panel/premium-pricing-panel.types';
import {toAppliedPromoCode} from '@Panels/premium-pricing-panel/premium-pricing-library';

export const getPlansForPricingDialog = createAsyncThunk('getPlansForPricingDialog', async () => {
  return window.PMW.readLocal('premium/getPlansForPricingDialog');
});

/**
 * The code is remembered only once the server has confirmed it is a live promotion, so a caller passing
 * a dead code cannot plant a cookie that later surfaces on the pricing page.
 */
export const getPromoCodeDetails = createAsyncThunk('getPromoCodeDetails', async (code: string): Promise<AppliedPromoCode | null> => {
  const response: unknown = await window.PMW.readLocal('premium/getPromoCodeDetails', {code: code});
  const appliedPromoCode = toAppliedPromoCode(code, response);
  if (appliedPromoCode === null) {
    return null;
  }

  setCookie(SUBSCRIPTION_PROMOTION_CODE_COOKIE, code, COOKIE_EXPIRY_1_HOUR);

  return appliedPromoCode;
});
